define('SuiteDynamics.Facets.Browse.View.Extended',
    [
        'Facets.Browse.View',
        'SC.Configuration',
        'underscore'
    ],
    function (
        FacetsBrowseView,
        Configuration,
        _
    )
{
    'use strict';

    _.extend(FacetsBrowseView.prototype, {
        getCanonical: function() {
            var full_url = this.getPath();
            var category_url = this.translator.getCategoryUrl();
            var facets = this.translator.getAllFacets();
            var canonical_url;

            if (facets.length > 1) {
                var base_index = full_url.indexOf(category_url);
                if (base_index !== -1) {
                    canonical_url = full_url.substring(0, base_index + category_url.length);
                } else {
                    canonical_url = full_url;
                }
            } else {
                canonical_url = full_url;
            }

            var current_page = this.translator.getOptionValue('page');
            if (current_page > 1) {
                canonical_url += '?page=' + current_page;
            }
            var canonicalUrlOverrides = Configuration.get('plpCanonicalUrls.urlOverrides') || [];
            var possibleMatches = _.filter(canonicalUrlOverrides, function(overrideObj) {
                return canonical_url.indexOf(overrideObj.canonicalUrl) !== -1;
            });

            if (possibleMatches && possibleMatches.length) {
                var matchedOverride = _.max(possibleMatches, function(overrideObj) {
                    return overrideObj.canonicalUrl.length;
                });
                canonical_url = canonical_url.replace(
                    matchedOverride.canonicalUrl,
                    matchedOverride.canonicalUrlOverride
                );
            }

            return canonical_url;
        }
    });
});
